module.exports = __webpack_public_path__ + "img/treppenhandlauf.dfd2b0b2.webp";